export const BANQUE_LESSONS_AR = [
  {
    id: 'banque-1',
    numero: 1,
    titre: "فتح حساب بنكي",
    sousTitre: "حقك وخياراتك",
    contexte: "فتح حساب بنكي في فرنسا — ما هي حقوقك والوثائق المطلوبة؟",
    explication: [
      "**الحق في حساب بنكي**: كل شخص يقيم في فرنسا له الحق في حساب بنكي — حتى لو رفضه بنك واحد.",
      "**Droit au compte**: إذا رفضك بنك، اذهب إلى Banque de France. ستعيّن لك بنكاً خلال 24 ساعة.",
      "**الوثائق المطلوبة**: وثيقة هوية سارية + إثبات إقامة أقل من 3 أشهر. هذا يكفي في معظم الحالات.",
      "**الحساب الأساسي**: خدمة مجانية تشمل بطاقة بنكية وتحويلات ودفعات — موجودة في كل بنك.",
      "**البنوك الإلكترونية**: Nickel (في التبغ)، Revolut، Orange Bank — تفتح حساباً في 5 دقائق بدون وثائق معقدة.",
    ],
    question: "رفضك بنك فتح حساب. ما حقك القانوني؟",
    options: [
      { id: 'a', text: "الاتصال بـ Banque de France التي ستعيّن لك بنكاً", correct: true },
      { id: 'b', text: "لا خيار — البنك حر في رفضك", correct: false },
      { id: 'c', text: "الشكوى للشرطة", correct: false },
    ],
    explication_reponse: "الحق في الحساب (Droit au compte) مكفول بالقانون. Banque de France ملزمة بتعيين بنك لك في 24 ساعة. الرقم: 3414.",
  },
  {
    id: 'banque-2',
    numero: 2,
    titre: "فهم بطاقتك البنكية",
    sousTitre: "استخدامها وحمايتها",
    contexte: "بطاقتك البنكية أداة يومية. كيف تستخدمها بأمان وما تفعله في حالة المشكلة؟",
    explication: [
      "**الرمز السري**: لا تعطِه لأحد أبداً — ولا للبنك نفسه. لا تكتبه على البطاقة.",
      "**الدفع بدون رمز (sans contact)**: مبالغ حتى 50 أورو بمجرد لمس البطاقة. مريح لكن انتبه للبطاقات المفقودة.",
      "**تعطيل بدون رمز**: إذا أردت تعطيله، اتصل ببنكك أو فعّل ذلك من تطبيق البنك.",
      "**في حالة الفقدان**: اتصل فوراً بـ 0892 705 705 (رقم الإيقاف الموحّد في فرنسا) لتجميد البطاقة.",
      "**الدفع الإلكتروني**: استخدم بطاقتك على المواقع الموثوقة فقط — ابحث عن 🔒 https في الشريط.",
    ],
    question: "ما الرقم للاتصال به فوراً عند فقدان البطاقة البنكية؟",
    options: [
      { id: 'a', text: "0892 705 705", correct: true },
      { id: 'b', text: "3414", correct: false },
      { id: 'c', text: "36 46", correct: false },
    ],
    explication_reponse: "0892 705 705 هو رقم إيقاف البطاقة الموحّد في فرنسا — يعمل 24/24، 7/7. يمكنك أيضاً الإيقاف من تطبيق بنكك مباشرة.",
  },
  {
    id: 'banque-3',
    numero: 3,
    titre: "إدارة حسابك بشكل صحيح",
    sousTitre: "تجنّب التجاوز والرسوم",
    contexte: "الحساب منخفض والشهر لم ينتهِ. كيف تتجنب الرسوم والتجاوزات؟",
    explication: [
      "**مراقبة الرصيد**: تحقق من رصيدك أسبوعياً على الأقل عبر تطبيق بنكك — لا مفاجآت.",
      "**التجاوز (découvert)**: إذا كان حسابك يسمح بتجاوز، الرسوم تبدأ فوراً. أبلغ بنكك إذا كنت في صعوبة.",
      "**الدفع المرفوض**: رسوم دفع مرفوض تصل إلى 30 أورو. تجنّبه بإلغاء تحويل تلقائي لا تستطيع تغطيته.",
      "**رسوم الحساب**: تحقق من اتفاقيتك — بعض الحسابات مجانية، بعضها له رسوم شهرية. قارن وغيّر إذا لزم.",
      "**Microcrédit**: إذا كنت في صعوبة مالية، Adie.org يقدم قروضاً صغيرة للأشخاص المرفوضين من البنوك.",
    ],
    question: "كيف تتجنب رسوم دفع مرفوض؟",
    options: [
      { id: 'a', text: "إلغاء أي تحويل تلقائي لا تستطيع تغطيته قبل موعده", correct: true },
      { id: 'b', text: "لا يمكن التحكم في ذلك", correct: false },
      { id: 'c', text: "دفع رسوم التجاوز مسبقاً للبنك", correct: false },
    ],
    explication_reponse: "يمكنك إلغاء أي تحويل تلقائي (منح التأمين، الإيجار...) من تطبيق بنكك قبل 5 أيام من تاريخه. هذا يتجنب الرسوم عند رصيد غير كافٍ.",
  },
  {
    id: 'banque-4',
    numero: 4,
    titre: "التحويلات والقروض",
    sousTitre: "كيف تتعامل مع البنك",
    contexte: "تريد إرسال مال أو اقتراض. ما يجب معرفته لتجنب الأخطاء والرسوم الزائدة.",
    explication: [
      "**التحويل SEPA**: بين حسابات أوروبية — مجاني في معظم البنوك، يصل في يوم عمل واحد.",
      "**RIB**: ضروري لأي تحويل أو تسديد — يحتوي IBAN وBIC. احصل عليه من تطبيقك أو شباك بنكك.",
      "**القرض الاستهلاكي**: قبل التوقيع، تحقق من TAEG (المعدل الفعلي الشامل). قارن بين البنوك.",
      "**تسبيق مال عبر الهاتف**: أي طريقة تحويل لا تعرفها (PayPal، Lydia، التحويل المصرفي لشخص مجهول) — تحقق قبل الإرسال.",
      "**الوصاية المالية**: إذا كنت في صعوبة مزمنة، يمكن طلب تقييد الإنفاق عبر Commission de surendettement.",
    ],
    question: "ما المستند الضروري لاستقبال أو إرسال تحويل بنكي؟",
    options: [
      { id: 'a', text: "RIB (الذي يحتوي IBAN)", correct: true },
      { id: 'b', text: "رقم الحساب فقط", correct: false },
      { id: 'c', text: "بطاقة البنك الفيزيائية", correct: false },
    ],
    explication_reponse: "RIB يحتوي على IBAN وBIC وجميع البيانات اللازمة للتحويل. احصل عليه من تطبيق بنكك في ثوانٍ وشاركه بأمان لاستقبال المدفوعات.",
  },
];
